// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3nB1A","col":"Table_col__1aT6N","fulfillmentStatus":"Table_fulfillmentStatus__22ceH","emailCol":"Table_emailCol__65isw"};